module.exports = __webpack_public_path__ + "img/p01.7bdd4fef.jpg";